import { assetUrl, config } from '../config';
import type { EmbeddingIndexFile, PokemonRecord } from '../types';

export interface LoadedData {
  pokemon: PokemonRecord[];
  embeddingFile: EmbeddingIndexFile;
}

async function fetchJson<T>(path: string): Promise<T> {
  const response = await fetch(assetUrl(path), { cache: 'no-cache' });
  if (!response.ok) {
    throw new Error(`读取 ${path} 失败：HTTP ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function loadPreparedData(): Promise<LoadedData> {
  const [pokemon, embeddingFile] = await Promise.all([
    fetchJson<PokemonRecord[]>(config.data.pokemonDataPath),
    fetchJson<EmbeddingIndexFile>(config.data.embeddingDataPath),
  ]);

  if (!pokemon.length || !embeddingFile.ids.length || !embeddingFile.data) {
    throw new Error('尚未生成图鉴数据。请先运行 npm run prepare:data。');
  }
  if (embeddingFile.modelId !== config.model.id) {
    throw new Error(
      `向量模型不一致：数据使用 ${embeddingFile.modelId}，配置使用 ${config.model.id}。请重新运行 npm run prepare:embeddings。`,
    );
  }

  return { pokemon, embeddingFile };
}
